import clsx from 'clsx';
import Link from 'next/link';
import { useContext } from 'react';
import { KaimonoWebRoutes } from 'src/config/routes';
import { CategoryContext } from 'src/stores/Category';
import { mapMiddleToSmallCategories } from 'src/utils/categoryMap';
import { mixpanel } from 'src/utils/mixpanel';
import styles from './index.module.scss';

type Props = {
  isSubNaviOpen: boolean;
};
export const SubNaviForPc: React.FC<Props> = ({ isSubNaviOpen }) => {
  const categories = useContext(CategoryContext);
  const middleCategories = mapMiddleToSmallCategories(categories);
  return (
    <div className={clsx(styles.container, isSubNaviOpen && styles.isOpen)}>
      <ul className={styles.categories}>
        {categories.largeCategories.map((largeCategory) => (
          <li className={styles.largeCategory} key={largeCategory.largeCategoryId}>
            <Link href={KaimonoWebRoutes.largeCategories.show(largeCategory.slug)}>
              <a
                className={styles.categoryName}
                onClick={() => mixpanel.onTopNavCategoryClicked('large', largeCategory.largeCategoryId)}
              >
                {largeCategory.name}
              </a>
            </Link>
            <div className={styles.middleCategories}>
              <Link href={KaimonoWebRoutes.largeCategories.show(largeCategory.slug)}>
                <a
                  className={styles.title}
                  onClick={() => mixpanel.onTopNavCategoryClicked('large', largeCategory.largeCategoryId)}
                >
                  {largeCategory.name}
                </a>
              </Link>
              <div className={styles.hr}></div>
              <div className={styles.descriptionWrap}>
                {middleCategories
                  ?.filter((mc) => largeCategory.middleCategoryIds.indexOf(mc.middleCategoryId) !== -1)
                  .map((middleCategory) => {
                    const smallCategories = middleCategory.smallCategories.map(({ smallCategoryId, slug }) => (
                      <Link href={KaimonoWebRoutes.smallCategories.show(slug)} key={smallCategoryId}>
                        <a
                          className={styles.smallCategory}
                          onClick={() => mixpanel.onTopNavCategoryClicked('small', smallCategoryId)}
                        >
                          {categories.smallCategories.find((sc) => sc.smallCategoryId === smallCategoryId)?.name}
                        </a>
                      </Link>
                    ));
                    return (
                      <div className={styles.smallCategoriesContainer} key={middleCategory.middleCategoryId}>
                        <Link href={KaimonoWebRoutes.middleCategories.show(middleCategory.slug)}>
                          <a
                            className={styles.middleCategory}
                            onClick={() => mixpanel.onTopNavCategoryClicked('middle', middleCategory.middleCategoryId)}
                          >
                            {middleCategory.name}
                          </a>
                        </Link>
                        <div className={styles.smallCategories}>{smallCategories}</div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
